/**
 * <s-card-fan>: a fanned stack of cards where hovering, tapping or focusing a
 * card brings it to the top. The raised card stays on top until another card
 * is raised. Lift/angle styling lives in CSS (hover/focus); this element only
 * manages stacking order.
 *
 * Markup contract: each card is a focusable element with [data-fan-card].
 */
class SCardFan extends HTMLElement {
  connectedCallback() {
    this.topZ = this.querySelectorAll('[data-fan-card]').length;
    this.handleRaise = (event) => {
      const card = event.target instanceof Element ? event.target.closest('[data-fan-card]') : null;
      if (!card || !this.contains(card)) return;
      if (card.dataset.fanTop === 'true') return;
      this.querySelectorAll('[data-fan-card][data-fan-top="true"]').forEach((other) => {
        other.dataset.fanTop = 'false';
      });
      this.topZ += 1;
      card.style.zIndex = String(this.topZ);
      card.dataset.fanTop = 'true';
    };
    this.addEventListener('pointerover', this.handleRaise);
    this.addEventListener('focusin', this.handleRaise);
    this.addEventListener('click', this.handleRaise);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.handleRaise);
    this.removeEventListener('focusin', this.handleRaise);
    this.removeEventListener('click', this.handleRaise);
  }
}

if (!customElements.get('s-card-fan')) {
  customElements.define('s-card-fan', SCardFan);
}
